import React from 'react';

const Vue_VIf = () => {
  return (
    <div>
      <h1>Vue_VIf Component</h1>
      <p>This is the Vue_VIf tutorial page.</p>
    </div>
  );
}

export default Vue_VIf;
